<template>
  <div>
    <v-container class="grey lighten-5">
      <v-row no-gutters class="pagination-table-header">
        <v-col
          col="12"
        >
          <v-overlay
            :absolute="true"
            :value="isComponentLoading"
          >
            <v-progress-circular indeterminate size="24"></v-progress-circular>
          </v-overlay>
          <v-card
            v-if="L.isEmpty(paginatedObject) || L.isEmpty(paginatedObject.data)"
            class="pa-3">
            <p class="text-center mt-2">
              <v-icon>mdi-account-search-outline</v-icon>
              <b>&nbsp;&nbsp;{{lang($store, 'sap/listings.subscriptions.not_found')}}&nbsp;&nbsp;</b>
              <v-icon>mdi-account-badge-outline</v-icon>
            </p>
          </v-card>
          <div v-else>
            <v-card
              v-for="(item, key) in paginatedObject.data"
              :key="key"
              :color="cardColor(item)"
              class="mx-auto pa-2 mb-2"
              style="border: 0"
              outlined
            >
              <div class="d-flex flex-row ">
                <daterange-alert
                  :moment-from="item.start"
                  :moment-to="item.end"
                />

                <v-chip
                  class="mx-2"
                  :small="false"
                > Создана: {{item.created_at}}
                </v-chip>

                <v-btn
                  icon
                  color="grey darken-2"
                  @click="onItemEdit(item)"
                >
                  <v-icon>mdi-account-edit-outline</v-icon>
                </v-btn>
                <v-btn
                  icon
                  color="grey darken-2"
                  @click="onItemDelete(item)"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </div>
              <v-card
                v-if="item.address"
              >
                <v-list-item>
                  <v-list-item-content class="">
                    <v-list-item-title
                      class="headline mb-1"
                      style="white-space: initial"
                    >{{item.address.contact.name}}
                      <div class="d-block d-sm-inline-block ml-0 ml-sm-2">
                        <a :href="'tel:' + item.address.contact.phone">
                          <v-chip
                            class="my-2"
                            style="cursor: pointer"
                            outlined
                          >
                            <v-avatar left>
                              <v-icon>mdi-cellphone</v-icon>
                            </v-avatar>
                            {{item.address.contact.phone}}
                          </v-chip>
                        </a>
                      </div>
                    </v-list-item-title>
                    <v-list-item-subtitle
                      style="white-space: initial">
                      {{item.address.contact.note}}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-alert
                  text
                  class="w-100 mb-0"
                >
                  <div>
                    <v-chip
                      class="mr-2 mb-2"
                      color="light-green darken-3"
                      outlined
                      text-color="light-green darken-3"
                    >
                      <v-icon left>mdi-home-city-outline</v-icon>
                      {{lang($store,
                      `sap/listings.global.filter.premises.${item.address.premises_type}`)}}
                    </v-chip>
                  </div>
                  <div>{{item.address.formatted}}</div>
                </v-alert>
              </v-card>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash';
/* constants */
import * as sources from '~constants/sources';
/* utils */
import { roles as rolesColors } from '../../utils/listingColors';
/* mixins */
import isComponentLoading from '../../mixins/isComponentLoading';
/* components */
import DaterangeAlert from '../minialerts/DaterangeAlert.vue';

export default {
  name: 'TablePaginatedSubscriptions',
  components: {
    DaterangeAlert,
  },
  mixins: [isComponentLoading],
  props: {
    paginatedObject: {
      type: Object,
      default: () => {
      },
    },
    noActions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rolesColors,
      sources,
      L: _,
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
  },
  methods: {
    cardColor(item) {
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      if (item.end < now) {
        return 'grey lighten-3';
      }
      return 'blue lighten-5';
    },
    onItemEdit(item) {
      this.$emit('edit-item', item);
    },
    onItemDelete(item) {
      this.$emit('delete-item', item);
    },
    onPreview(item) {
      this.$emit('preview-item', item);
    },

    onAddressEdit(item, address) {
      this.$emit('edit-address', {
        item,
        address,
      });
    },
    onAddressDelete(item, address) {
      this.$emit('delete-address', {
        item,
        address,
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  .table-action
    &:hover
      fill: #0066ff
      transition: fill 0.5s
      cursor: pointer
</style>
